import { getLoyaltyItemById } from './get-loyalty-item-by-id';
export const getGroupForLoyaltyItem = (id) => {
    var _a, _b;
    return (_b = (_a = getLoyaltyItemById(id)) === null || _a === void 0 ? void 0 : _a.itemClass) === null || _b === void 0 ? void 0 : _b.group;
};
